/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Checks that its argument is neither undefined nor null.
 *
 * @param x - Something to be checked.
 *
 * @returns - Returns if its argument exists.
 */
function exists<T>(x: T): x is NonNullable<T> {
  return typeof x !== 'undefined' && x !== null;
}

/**
 * Checks if something should be considered as true, meaning not false and
 * existing.
 *
 * @param x - Something to be checked.
 *
 * @returns - Returns if its argument is considered truthy.
 */
function truthy<T>(x: T): x is NonNullable<T> & Exclude<T, false> {
  return (x as any) !== false && exists(x);
}

export { exists, truthy };
